import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { packaging } from 'global/Models/packagingModel';

interface MyPackagesState {
  items: packaging[];
}
const initialState: MyPackagesState = { items: [] };

const myPackagesSlice = createSlice({
  name: 'myPackages',
  initialState,
  reducers: {
    addMyPackage: (state, action: PayloadAction<packaging>) => {
      state.items = [action.payload, ...state.items.filter((p) => p.id !== action.payload.id)];
    },
    removeMyPackage: (state, action: PayloadAction<number | string>) => {
      state.items = state.items.filter((p) => String(p.id) !== String(action.payload));
    },
    setMyPackages: (state, action: PayloadAction<packaging[]>) => {
      state.items = action.payload ?? [];
    },
    clearMyPackages: (state) => {
      state.items = [];
    },
  },
});

export const { addMyPackage, removeMyPackage, setMyPackages, clearMyPackages } = myPackagesSlice.actions;
export default myPackagesSlice.reducer;
